import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import ClassNames from "classnames";
import _ from "lodash";

import Bus from "../utils/bus";
let BUS = new Bus();

class Press extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.renderLogo = this.renderLogo.bind(this);
    this.renderText = this.renderText.bind(this);
  }

  renderLogo(logo, i) {
    if (logo.url !== "") {
      return (
        <a
          href={logo.url}
          target="_blank"
          key={i}
          className="image"
          style={{ backgroundImage: `url(${logo.image.url})` }}
        />
      );
    } else {
      return (
        <div
          key={i}
          className="image"
          style={{ backgroundImage: `url(${logo.image.url})` }}
        />
      );
    }
    return null;
  }

  renderText(text) {
    if (text !== "") {
      return <blockquote>{text}</blockquote>;
    }
    return null;
  }

  render() {
    let logos = this.props.items;

    return (
      <div className="Press">
        <div className="items">
          {logos.map((logo, i) => {
            return (
              <div className="item" key={i}>
                {this.renderLogo(logo, i)}

                {this.renderText(logo.pressQuote)}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Press;



// WEBPACK FOOTER //
// ./src/home/press.js